var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
import { currentRoomsVar } from './currentRooms';
import { selectRoomMetric } from './selectRoomMetric';
const SELECT_ROOMS_AND_FLIGHT_MUTATION = gql `
    mutation SelectRoomsAndFlight($request: SelectRoomsAndFlightRequest!) {
        selectRoomsAndflight(request: $request) {
            basket {
                hotelProducts {
                    lineItems {
                        description
                        typeId
                        unitAmount
                        unitAmountFormatted
                        quantity
                    }
                    itinerary {
                        ... on BasketHotelItinerary {
                            mandatoryExtras {
                                title
                                options {
                                    hotelExtraOptionId
                                    customerText
                                }
                                hotelExtraTypeId
                                hotelExtraId
                            }
                        }
                    }
                }
            }
            tripStateId
            searchParameters {
                tripStateId
                tripType
            }
        }
    }
`;
export function useRoomsAndFlight(onCompleted, onError) {
    const [selectRoomsAndFlightMutation, selectRoomsAndFlightState] = useMutation(SELECT_ROOMS_AND_FLIGHT_MUTATION, {
        onError: (err, operation) => {
            var _a, _b;
            if (onError === null || onError === void 0 ? void 0 : onError.length)
                callSideEffects(onError, err);
            selectRoomMetric(((_a = operation === null || operation === void 0 ? void 0 : operation.variables) === null || _a === void 0 ? void 0 : _a.request.tripStateId) || 'no trip Id', err.graphQLErrors);
            currentRoomsVar(Object.assign(Object.assign({}, currentRoomsVar()), {
                rooms: (_b = currentRoomsVar().rooms) === null || _b === void 0 ? void 0 : _b.map((el) => (Object.assign(Object.assign({}, el), { isConfirmed: false }))),
                soldOut: true,
                selectedRoomIndex: 0,
            }));
        },
        onCompleted: (mutationData) => {
            var _a;
            selectRoomMetric(((_a = mutationData.selectRoomsAndflight) === null || _a === void 0 ? void 0 : _a.tripStateId) || 'no trip Id');
            if (mutationData === null || mutationData === void 0 ? void 0 : mutationData.selectRoomsAndflight) {
                callSideEffects(onCompleted, mutationData.selectRoomsAndflight);
            }
        },
    });
    const selectRoomsAndFlight = (request) => __awaiter(this, void 0, void 0, function* () {
        yield selectRoomsAndFlightMutation({
            variables: { request },
        });
    });
    return { selectRoomsAndFlight, selectRoomsAndFlightState };
}
